import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

const LINKEDIN = 'https://www.linkedin.com/in/guntars-dikis-a85b6042/';
const WHATSAPP = 'https://wa.me/37129438427';
const GITHUB = 'https://github.com/guntarsdikis';
const LEGAL_EMAIL = 'info@gdwd.lv';
const LEGAL_ADDRESS = '"Liepdārzi 15", Baldones pag., Ķekavas nov., LV-2125';

export default function SiteFooter() {
  const { lang } = useLanguage();
  const registrationLabel = lang === 'lv' ? 'Reģ. Nr.' : 'Reg. No.';
  const addressLabel = lang === 'lv' ? 'Juridiskā adrese' : 'Legal address';

  return (
    <footer className="gdwd-footer">
      <div className="gdwd-footer__inner">
        <div className="gdwd-footer__legal">
          <strong className="gdwd-logo" style={{ fontSize: 18 }}>
            gdwd<span>.</span>
          </strong>
          <div className="gdwd-footer__company">SIA GDWD</div>
          <div>{registrationLabel} 40103981811</div>
          <div>{addressLabel}: {LEGAL_ADDRESS}</div>
        </div>
        <div className="gdwd-footer__links">
          <a href={`mailto:${LEGAL_EMAIL}`}>{LEGAL_EMAIL}</a>
          <a href={WHATSAPP} target="_blank" rel="noopener noreferrer">
            WhatsApp
          </a>
          <a href={LINKEDIN} target="_blank" rel="noopener noreferrer">
            LinkedIn
          </a>
          <a href={GITHUB} target="_blank" rel="noopener noreferrer">
            GitHub
          </a>
        </div>
      </div>
    </footer>
  );
}
